export const ContactAddingList = [
    {
        label: "Էլ․ հասցե",
        inputType: "input",
        type: "text",
        placeholder: "Էլ․ հասցե",
        name: "email",
        maxLength: 500
    },
    {
        label: "Հեռախոս",
        inputType: "input",
        type: "text",
        regExp:/^[+\d]\d*$/,
        placeholder: "Հեռախոս",
        name: "phoneNumber",
        maxLength: 20
    },
    {
        label: "Երկրորդ հեռախոսահամար",
        inputType: "input",
        type: "text",
        regExp:/^[+\d]\d*$/,
        placeholder: "Երկրորդ հեռախոսահամար",
        name: "phoneNumber2",
        maxLength: 20
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "YouTube",
        name: "youtubeLink",
        maxLength: 2000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Facebook",
        name: "facebookLink",
        maxLength: 2000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Instagram",
        name: "instagramLink",
        maxLength: 2000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Linkedin",
        name: "linkedinLink",
        maxLength: 2000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "Tik-Tok",
        name: "tiktokLink",
        maxLength: 1000
    },
    {
        inputType: "input",
        type: "text",
        placeholder: "YouTube Video Link",
        name: "youtubeVideoLink",
        maxLength: 1000
    },
];
